import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Benefits from './components/Benefits';
import PainPoints from './components/PainPoints';
import Features from './components/Features';
import Testimonials from './components/Testimonials';
import CallToAction from './components/CallToAction';
import Footer from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-[#FFFCF8]" data-id="element-0">
      <Navbar data-id="element-1" />
      <main className="w-full" data-id="element-2">
        <Hero data-id="element-3" />
        <Benefits data-id="element-4" />
        <PainPoints data-id="element-5" />
        <Features data-id="element-6" />
        <Testimonials data-id="element-7" />
        <CallToAction data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}